// Типы для параметров тоста
export type SnackBarType = 'success' | 'error' | 'info';

export interface SnackBarOptions {
  message: string;
  type?: SnackBarType;
  duration?: number; // Длительность в миллисекундах, 0 — для постоянного тоста
  position?: SnackBarPosition; // Позиция, по умолчанию 'bottom'
  dismissible?: boolean; // Показывать ли кнопку закрытия, по умолчанию false
}

// Тип для позиции тоста
export type SnackBarPosition =
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left'
  | 'bottom'
  | 'top';

// Тип для объекта тоста
export interface SnackBar {
  id: number;
  message: string;
  type: SnackBarType;
  position: SnackBarPosition;
  dismissible: boolean;
}

class SnackBarManager {
  snackBars: Ref<SnackBar[]>;
  maxSnackBarsShown: Ref<number>;
  private lastId = 1;
  private lastUsedPosition: SnackBarPosition = 'bottom'; // Отслеживаем последнюю использованную позицию

  constructor(maxSnackBarsShown = 100) {
    this.snackBars = ref([]);
    this.maxSnackBarsShown = ref(maxSnackBarsShown);
  }

  showSnackBar(options: SnackBarOptions) {
    const {
      message,
      type = 'success',
      duration = 3000,
      position = this.lastUsedPosition, // Используем последнюю позицию вместо хардкода
      dismissible = options.duration === 0,
    } = options;

    // Обновляем последнюю использованную позицию
    this.lastUsedPosition = position;

    const id = ++this.lastId;

    const newSnackBar: SnackBar = { id, message, type, position, dismissible };
    this.snackBars.value.push(newSnackBar);

    if (duration > 0) {
      setTimeout(() => {
        this.dismissSnackBar(id);
      }, duration);
    }

    return {
      id,
      dismiss: () => this.dismissSnackBar(id),
      isActive: () => this.snackBars.value.findIndex((e) => e.id === id) > -1,
    };
  }

  dismissSnackBar(id: number) {
    this.snackBars.value = this.snackBars.value.filter((snackBar) => snackBar.id !== id);
  }

  setMaxSnackBarsSown(n: number) {
    this.maxSnackBarsShown.value = n;
  }

  // Геттер для получения последней использованной позиции
  getLastUsedPosition(): SnackBarPosition {
    return this.lastUsedPosition;
  }
}

export const snackBarManager = new SnackBarManager();
